import request, { requestV1 } from "@/config/serve.js";
// 查询
export function getCategoryList(params) {
  return requestV1("post", "/oobeReport/list", {
    deleted: false,
    ...params,
  });
}
// 下载来源
export function getDownloadSource(params = {}, loading = false) {
  return requestV1(
    "post",
    "/oobeReport/dropDownList",
    {
      deleted: false,
      ...params,
    },
    loading
  );
}
